module.exports = __webpack_public_path__ + "img/lower_cheeks.d2365919.svg";